// import noScroll from 'no-scroll';

export const drawer = () => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  (function(window, document, $) {
    const $drawer = $('.drawer'); // NOTE ライブラリのCSSが.drawerを利用しているため.js-への変更は手間がかかる
    const $drawerNav = $('.drawer-nav > div'); // NOTE ライブラリのCSSが.drawerを利用しているため.js-への変更は手間がかかる
    const bodyElement = document.body;
    if ($drawer.length === 0 || !bodyElement) return;

    const drawerOpen = (): void => {
      bodyElement.classList.remove('drawer-close');
      bodyElement.classList.add('drawer-open');
      $drawerNav.scrollTop(0);
      // if (typeof noScroll === 'object') {
      //   noScroll.on();
      // }
    };
    const drawerClose = (): void => {
      bodyElement.classList.remove('drawer-open');
      bodyElement.classList.add('drawer-close');
      // if (typeof noScroll === 'object') {
      //   noScroll.off();
      // }
    };
    const drawerDestroy = (): void => {
      // $drawer.drawer('close').drawer('destroy');
      bodyElement.classList.remove('drawer-open');
      bodyElement.classList.remove('drawer-close');
    };

    const drawerIsInitialized = () => {
      return bodyElement.classList.contains('drawer-close') || bodyElement.classList.contains('drawer-open');
    };

    const drawerIsClose = (): boolean => bodyElement.classList.contains('drawer-close');

    bodyElement.classList.add('drawer-close');
    drawerIsInitialized();

    const $drawerToggle = $('.drawer-toggle');
    $drawerToggle.on('touchend click', (e) => {
      e.preventDefault();
      if (drawerIsClose()) {
        drawerOpen();
      } else {
        drawerClose();
      }
    });


    // const drawerBreakpoint = window.matchMedia('(min-width: 768px)'); // NOTE できればCSS Variablesを参照する
    // const handleMediaQuery = (mediaQuery) => {
    //   if (mediaQuery.matches) {
    //     if (drawerIsInitialized()) {
    //       drawerDestroy();
    //     }
    //   } else {
    //     if (drawerIsInitialized()) return;
    //
    //     // $drawer.drawer();
    //     // $(window).off('resize.drawer');
    //     // $drawer.drawer({
    //     //   class: {
    //     //     nav: 'js-drawer-nav',
    //     //     toggle: 'js-drawer-toggle'
    //     //   }
    //     // });
    //     // $drawer.drawer({
    //     //   class: {
    //     //     nav: 'js-drawer-nav',
    //     //     toggle: 'js-drawer-toggle-sticky'
    //     //   }
    //     // });
    //   }
    // };
    // // Register
    // handleMediaQuery(drawerBreakpoint);
    // drawerBreakpoint.addListener(handleMediaQuery);
  })(window, document, jQuery);
};
